import PressIcon from './PressIcon'

export default PressIcon